import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { Plus } from 'react-feather';
import Actions from '../../../Actions';

class AddButton extends Component {
    toggleModal = () => {
        const { type, data = false, toggleModal, setModalData } = this.props;
        if(data !== false){
            setModalData(type,"add",data);
        }

        toggleModal(type,"add");
    }

    render(){
        return(
            <div>
                <Button onClick={this.toggleModal} className="btn btn-danger"><Plus style={{ strokeWidth: "3px", verticalAlign: "text-bottom"}} size={18}/></Button>
            </div>
        );
    }
}

const { modals } = Actions;

export default connect(null, modals)(AddButton);


// WEBPACK FOOTER //
// ./src/Components/App/Layout/AddButton.js